export const c_drawer__panel_md_FlexBasis = {
  "name": "--pf-v6-c-drawer__panel--md--FlexBasis",
  "value": "50%",
  "var": "var(--pf-v6-c-drawer__panel--md--FlexBasis)"
};
export default c_drawer__panel_md_FlexBasis;